<template>
  <ion-page>
    <master-layout pageTitle="<i class='fal fa-shipping-fast'></i>&nbsp; اطلاعات ارسال">

      <Loading :is="!shippingLoaded" v-if="!shippingLoaded"></Loading>
      <div v-if="shippingLoaded && !addressDiv">
      <ion-card>
        <ion-card-header>
          <ion-card-title>آدرس ها</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div v-if="addresses.length && defaultAddress">
          <div class="info-items">
            <div>تحویل گیرنده : </div>
            <div>{{defaultAddress.fullname}}</div>
          </div>
          <div class="info-items">
            <div>شماره تماس : </div>
            <div>0{{defaultAddress.phone}}</div>
          </div>
          <div class="info-items">
            <div>کدپستی : </div>
            <div>{{defaultAddress.postal_code}}</div>
          </div>
          <div class="info-items">
            آدرس :
              {{defaultAddress.state.title}},
              {{defaultAddress.city.title}},
              {{defaultAddress.address}}
          </div>
          <ion-button @click="addressDiv = true" color="secondary" expand="full">تغییر آدرس</ion-button>
          </div>
          <div v-else>
            <div class="text-danger">شما آدرسی ثبت ندارید.</div>
            <router-link to="/Address/Add">
            <ion-button color="tertiary" expand="full" >افزودن آدرس</ion-button>
            </router-link>
          </div>

        </ion-card-content>
      </ion-card>
      
      <ion-card>
        <ion-card-header>
          <ion-card-title>استفاده از کد تخفیف</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div>
            با ثبت کد تخفیف مبلغ مشخص از "مبلغ قابل پرداخت" کسر خواهد شد.
          </div>
          <div>
            <input v-model="discountCode" type="text" name="discountCode" placeholder="مثلا : CAR1234566" class="form-control">
          </div>
          <ion-button @click="submitDiscount" color="success" expand="full">ثبت کد تخفیف</ion-button>
          <div v-if="discount">
            <div>عنوان :
              {{discount.title}}
            </div>
            <div>مبلغ تخفیف :
              <money :number="discountAmount"></money> تومان
            </div>
            <div v-if="discount.free_shipping" class="text-danger">
              کد تخفیف شامل حمل ونقل رایگان می باشد.
            </div>
          </div>
        </ion-card-content>
      </ion-card>

        <ion-card>
          <ion-card-content>
            <div v-if="checkDefaultAddress">
              <div>هزینه ارسال :
<!--              <money :number="sendCost"></money>-->
                {{sendCost}}
              </div>
              <div>مدت زمان ارسال :
                <money :number="nDeliverDay"></money> روز کاری
              </div>
            </div>
            <div v-else class="text-danger">
              امکان ارسال به شهر آدرس انتخابی وجود ندارد. لطفا آدرس را عوض کنید
            </div>
          </ion-card-content>
        </ion-card>

      <ion-card>
        <ion-card-header>
          <ion-card-title>اطلاعات کلی</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="info-items">
            <div>جمع کل خرید شما :</div>
            <div>
              <money :number="original_total"></money>
              تومان
            </div>
          </div>
          <div class="info-items">
            <div>هزینه ارسال :</div>
            <div>
<!--              <money :number="sendCost"></money>-->
              {{sendCost}}
              تومان</div>
          </div>
          <div class="info-items text-success">
            <div>مبلغ قابل پرداخت :</div>
            <div><money :number="total"></money>
              تومان</div>
          </div>
          <div class="info-items text-danger">
            <div>سود شما از خرید :</div>
            <div><money :number="special_discount"></money>
              تومان</div>
          </div>
          <ion-button @click="submitOrder" color="tertiary" expand="full">
            <strong>تایید و ثبت سفارش</strong>&nbsp;<i class="fal fa-arrow-left ic"></i>
          </ion-button>
        </ion-card-content>
      </ion-card>
        <h4>آیتم های سفارش</h4>
            <div id="plans-list">
              <div v-for="item in cart_items" :key="item._id" class="brand-model-item item">
                <div class="thumbnail">
                  <img :src="item.pic_url"/>
                </div>
                <div class="title">
                  <h4>{{ item.item_title }}</h4>
                  <div class="c-attr">{{item.attributes}}</div>
                </div>
                <div v-if="item.provider">
                  <div class="mb-1">
                    <i class="far fa-store"></i>
                    {{item.provider.title}}
                  </div>
                </div>
                <div class="justify-between mb-1 quantity">
                  <div> تعداد :</div>
                  <div>{{item.quantity}}</div>
                </div>
                <div class="price">
                  <div v-if="item.provider">

                    <div class="justify-between mb-1">
                      <div>قیمت :</div>
                      <div>
                        <div v-if="item.percent">
                          <del><money :number="item.original_price"></money></del>
                          <span class="percent">{{item.percent}}%</span>
                        </div>
                        <money :number="item.price"></money>
                        تومان
                      </div>
                    </div>
                    <div class="justify-between mb-1">
                      <div>جمع :</div>
                      <div>
                        <money :number="item.total"></money>
                        تومان
                      </div>
                    </div>
                  </div>
                  <b v-else class="text-success">
                    قیمت گذاری بعد از بررسی انجام می شود
                  </b>

                </div>
                <div class="justify-between">
                <div v-if="item.unit_type === 'big'" class=" text-danger">
                  واحد :
                  {{item.bigger_unit_title}}
                </div>
                <div v-if="item.unit_type === 'big'" class=" text-danger">
                  تعداد در هر {{item.bigger_unit_title}} :
                  {{item.bigger_unit_quantity}}
                </div>
                </div>
              </div>
            </div>
      </div>
      <div v-if="addressDiv && !error">
        <router-link to="/Address/Add">
          <ion-button color="success" expand="full">افزودن آدرس جدید</ion-button>
        </router-link>
        <ion-card v-for="(item,index) in addresses" :key="index">
          <ion-card-content>
            <div class="info-items">
              <div>تحویل گیرنده : </div>
              <div>{{item.fullname}}</div>
            </div>
            <div class="info-items">
              <div>شماره تماس : </div>
              <div>0{{item.phone}}</div>
            </div>
            <div class="info-items">
              <div>کدپستی : </div>
              <div>{{item.postal_code}}</div>
            </div>
            <div class="info-items">
              آدرس :
              {{item.state.title}},
              {{item.city.title}},
              {{item.address}}
            </div>
            <ion-button @click="setAddressToDefault(item._id)" color="secondary" expand="full">انتخاب آدرس</ion-button>
          </ion-card-content>
        </ion-card>
        <ion-button @click="addressDiv = false" color="danger" expand="full">بازگشت</ion-button>
      </div>
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

    </master-layout>
   </ion-page>
</template>

<script>
import {IonGrid, IonRow, IonCol, IonPage,IonCard,IonCardContent} from '@ionic/vue'
import {mapActions} from "vuex";
import Money from "@/components/Money";
import {showSystemNoti} from "@/shared/helper";


export default {
  data: function ()
  {
    return {
      id: null,
      shipping : null,
      shippingLoaded : false,
      error : false,
      defaultAddress : null,
      cart_items : [],
      checkDefaultAddress : false,
      sendCost : 0,
      first_send_cost : 0,
      nDeliverDay : 0,
      addresses : [],
      total : 0,
      original_total : 0,
      addressDiv : false,
      discountCode : null,
      discountAmount :0,
      discount : null,
      cartError : false,
      special_discount : 0
    }
  },
  async created()
  {
    await this.init();
  },
  mounted()
  {

  },
  methods: {
    ...mapActions("shop", {
      getShippingItem: 'getShippingItem',
      submitDiscountCode : 'submitDiscountCode',
      submitOrderFnuc : 'submitOrder'
    }),
    ...mapActions("address", {
      setDefaultAddress: 'setDefaultAddress',
    }),
    calculateTotal()
    {
      const items = this.cart_items;
      let total = 0;
      let original_total = 0;
      let special_discount = 0;
      for (let i = 0; i < items.length; i++)
      {
        total += items[i].total;
        special_discount += items[i].special_discount;
        original_total += items[i].quantity * items[i].original_price;
      }
      let sendCost = this.sendCost;
      if (sendCost)
        total += parseInt(sendCost);
      this.total = total - this.discountAmount;
      this.original_total = original_total;
      this.special_discount = special_discount +this.discountAmount;
    },
    async init()
    {
      const self = this;
      this.shipping = false;
      this.shippingLoaded = false;
      this.addresses = [];
      this.error = false;
      this.defaultAddress = null;
      this.cart_items = null;
      this.checkDefaultAddress = false;
      this.sendCost = 0;
      this.addressDiv = false;
      this.nDeliverDay = 0;
      this.discountCode = null;
      this.discountAmount =0;
      this.discount = null;
      this.cartError = false;
      const result = await this.getShippingItem({id: this.id});
      if (result)
      {
        if (result.ok)
        {
          if (result.cartError)
          {
            return showSystemNoti('danger','قیمت یا موجودی تعدادی از آیتم ها تغییر کرده است',function (){
              self.$router.push({path : 'ShopCart'})
            })
          }
          this.shippingLoaded = true;
          this.cart_items = result.cart_items;
          this.addresses = result.addresses;
          this.sendCost = result.send_cost;
          this.first_send_cost = result.send_cost;
          this.nDeliverDay = result.n_deliver_day;
          this.checkDefaultAddress = result.check_default_address;
          if (this.addresses.length)
          {
            for (let i = 0; i < this.addresses.length; i++)
            {
              if (this.addresses[i].default)
              {
                this.defaultAddress = this.addresses[i];
                break;
              }
            }
          }
          this.calculateTotal()
        }
        else
        {
          this.shippingLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.customerLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    async setAddressToDefault(id)
    {
      const check = await this.setDefaultAddress(id);
      if (check.ok)
      {
        await this.init();
      }
      else
          return showSystemNoti('danger',check.error);
    },
    async submitDiscount()
    {
      const discountCode = this.discountCode;
      if (!discountCode || discountCode === '')
        return showSystemNoti('danger','کد تخفیف نباید خالی باشد.');
      const check = await this.submitDiscountCode(discountCode);
      if (check.ok)
      {
        this.discount = check.discount;
        this.discountAmount = check.discountAmount;
        if(this.discount.free_shipping)
          this.sendCost = 0;
        this.calculateTotal();
        console.log('first_send_cost'+this.first_send_cost)
      }
      else
      {
        this.discount = null;
        this.discountAmount = 0;
        this.sendCost = this.first_send_cost;
        this.calculateTotal();
        return showSystemNoti('danger',check.error);
      }

    },
    async submitOrder()
    {
      const self = this;
     const check = await this.submitOrderFnuc(this.discountCode);
     if (check.ok)
     {
       const id = check.id;
      self.$router.push({path : '/Payment/'+id})
     }
     else
     {
       return showSystemNoti('danger', check.error,function ()
       {
         if (check.change)
           self.$router.push({path : '/ShopCart'})
       });
     }
    }
  },
  components: {
    Money,
    IonGrid, IonRow, IonCol, IonPage,IonCard,IonCardContent
  },
  props:{
    default:null
  },
  watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('shipping') >= 0)
        {
          console.log('ok')
          this.init();
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>

.info-items{
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px solid #c0c0c091;
}
#plans-list {
  overflow-x: auto;
  padding: 15px 5px;
  display: flex;
  flex-direction: row;
}
.brand-model-item {
  display: block;
  height: 450px;
  margin-left: 15px;
  width: 100%;
  min-width: 250px;
}
.thumbnail{
  height: 186px;
}
.thumbnail img {
  height: 180px;
  margin: 0 auto;
}
.brand-model-item > *{
  max-width: 100%;
}
.title h4 {
  color: #172e79;
  font-size: 20px !important;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
  white-space: break-spaces;
}
.price del {
  display: inline;
  color: red;
}
.price div {
  display: block;
  color: #222222;
}
.price {
  height: 85px;
  font-size: 15px;
}
.c-attr {
  height: 27px;
  font-size: 15px;
}
.justify-between
{
  display: flex !important;
  justify-content: space-between;
}
.percent {
  background: #eb445a;
  color: white;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 3px;
}
.quantity
{
  font-size: 15px;
  margin-bottom: 5px;
}
</style>